<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="contractForm" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem label="车库名称:" prop="parkingName">
          <Input v-model="formFields.parkingName" placeholder="请输入车库名称..." size="small" />
        </FormItem>
        <FormItem label="合同有效期:" prop="expireTime">
          <DatePicker
            type="date"
            placeholder="请选择合同有效期"
            size="small"
            style="width:100%"
            :value="formFields.expireTime"
            @on-change="handleExpireDateChange"
          />
        </FormItem>
        <!-- <FormItem label="车库城市:">
          <AreaCascader v-model="area" size="small" level="2" style="margin-top: 6px" data-type="name" @on-change="onAreaChange" />
        </FormItem> -->
        <FormItem label="运营日期:" prop="parkingOnline">
          <DatePicker
            type="date"
            placeholder="请选择运营日期"
            size="small"
            style="width:100%"
            :value="formFields.parkingOnline"
            @on-change="handleDateChange"
          />
        </FormItem>
        <FormItem label="车库容量:" prop="parkingCapacity">
          <Input v-model="formFields.parkingCapacity" placeholder="请输入车库容量..." size="small" number />
        </FormItem>
        <FormItem label="合同备注:" prop="remarks">
          <Input v-model="formFields.remarks" placeholder="请输入备注..." size="small" />
        </FormItem>
        <FormItem label="合同上传:">
          <div style="position: relative">
            <div class="p_container">
              <div
                v-for="(photo, index) in photos"
                :key="index"
                class="p_wrapper"
                style="text-align: center; font-size: 9pt"
              >
                <div class="image_container" :style="'border: 1px solid ' + (photosUploaded[index] === 1 || photosPath[index] ? 'red' : '#ccc')">
                  <!-- <vue-viewer v-if="photo && photo.full" :thumb="photo.thumb" :full="photo.full" /> -->
                  <!-- <div v-else> -->
                  <FileUploader
                    :ref="'uploader' + index"
                    :max-count="1"
                    :auto-upload="false"
                    :show-tips="false"
                    accept=".jpg,.png,.jpeg,.bmp"
                    button-type="default"
                    :show-button-text="false"
                    :index="index"
                    button-text=""
                    action="/file/upload"
                    icon="ios-add"
                    @on-upload="onFileUpload"
                    @on-before-upload="onFileBeforeUpload"
                  />
                  <!-- </div> -->
                </div>
                <div>分页照{{ index + 1 }}</div>
              </div>
            </div>
          </div>
        </FormItem>
        <!-- <FormItem label="合同上传:">
          <FileUploader
            ref="contractFileUpload"
            :max-count="9"
            :auto-upload="false"
            :multiple="true"
            accept=".jpg,.png,.jpeg,.bmp"
            button-type="default"
            button-text="选择合同文件..."
            @on-upload="onFileUpload"
            @on-before-upload="onFileBeforeUpload"
          />
          <div v-if="uploadFile !== null" class="text-ellipsis" :title="uploadFile.name" :loading="loadingStatus" style="font-size: 9pt;">
            已选择文件: {{ uploadFile.name }}
          </div>
        </FormItem> -->
        <input v-model="formFields.id" type="hidden" name="id"></input>
      </Form>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
// import AreaCascader from '@/components/area-cascader'
import FileUploader from '@/components/file-upload'
import request from '@/utils/request'
import { applyObject } from '@/utils/util'
export default {
  name: 'ContractFormDialog',
  components: { FileUploader },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    const size = 9
    const photos = []
    const photosUploaded = []
    const photosPath = []
    for (var i = 1; i < size; i++) {
      photos.push('')
      photosUploaded.push(0)
      photosPath.push('')
    }
    return {
      uploadFile: null,
      loadingStatus: false,
      modal: true,
      submit: false,
      photos: photos,
      photosUploaded: photosUploaded,
      photosPath: photosPath,
      // area: [],
      formFields: {
        parkingName: '',
        file: null,
        // type: '',
        remarks: '',
        // province: '',
        // city: '',
        // district: '',
        expireTime: '',
        parkingCapacity: 0,
        id: this.id,
        parkingOnline: ''
      }
    }
  },
  computed: {
    ruleValidate() {
      return {
        parkingName: [{ required: true, message: '车库名不能为空!', trigger: 'blur' }],
        // parkingOnline: [{ required: true, message: '车库运营日期不能为空!!', trigger: 'blur' }],
        expireTime: [{ required: true, message: '合同过期时间不能为空!!', trigger: 'blur' }]
      }
    },
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑合同' : '添加新合同'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    }
  },
  watch: {
    showModal(val) {
      this.resetForm()
      this.loadingStatus = false
      if (this.action && this.id) {
        this.loadingStatus = true
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          this.loadingStatus = false
          applyObject(res.data, this.formFields)
          // const photosUploaded = []
          const photoList = res.data.contract.split(',')
          // const photosPath = []
          for (const index in photoList) {
            // photosUploaded.push(photo ? 1 : 0)
            // photosPath.push(photo)
            this.$set(this.photosPath, index, photoList[index])
          }
          // this.photosUploaded = photosUploaded
          // this.photosPath = photosPath
          // this.$set(this.photosPath, )
          // this.formFields = res.data
        }).catch(() => {
          this.loadingStatus = false
        })
      }
    }
  },
  methods: {
    resetForm: function() {
      this.uploadFile = null
      this.$refs.contractForm.resetFields()
      this.formFields.id = 0
      this.formFields.file = null
    },
    handleDateChange: function(date) {
      this.formFields.parkingOnline = date
    },
    handleExpireDateChange: function(date) {
      this.formFields.expireTime = date
    },
    // onAreaChange(data) {
    //   if (data.length > 0 && data.length === 3) {
    //     this.formFields = { ...this.formFields, province: data[0], city: data[1], district: data[2] }
    //   } else {
    //     this.formFields = { ...this.formFields, province: '', city: '', district: '' }
    //   }
    // },
    onFileBeforeUpload(file, index) {
      this.uploadFile = file
      console.log(file, index)
      this.$set(this.photos, index, file)
      this.$set(this.photosUploaded, index, 1)
      // if (!this.formFields.name) {
      // this.formFields.name = file.name
      // }
    },
    onFileUpload(file, index) {
      this.loadingStatus = false
      console.log(file, index)

      // if (this.formFields.name) {
      // file.name = this.formFields.name
      // }
    },
    async uploadPhotos() {
      const _this = this
      for (const index in this.photosUploaded) {
        if (this.photosUploaded[index]) {
          const formData = new FormData()
          formData.append('file', this.photos[index], 'photo.png')
          await request({
            url: _this.$config.apiContextPath + '/file/upload',
            method: 'POST',
            data: formData
          }).then(res => {
            _this.$set(_this.photosPath, index, res.data)
            // _this.$set(_this.photosUploaded, index, res.data)
          }).catch(() => {
            _this.$Notice.error({ title: '分页照' + index + '上传失败' })
          })
        }
      }
    },
    validate() {
      if (this.formFields.parkingName.trim().length < 1) {
        this.$Notice.error({ title: '请输入车库名..' })
        return false
      }
      if (this.formFields.expireTime.trim().length < 1) {
        this.$Notice.error({ title: '请输入合同过期时间..' })
        return false
      }
      if (this.formFields.parkingCapacity < 0) {
        this.$Notice.error({ title: '车库容量不能小于0..' })
        return false
      }
      return true
    },
    async saveOrUpdate() {
      const _this = this
      // this.validate()
      if (this.validate()) {
        this.submit = true
        await _this.uploadPhotos()
        // this.$refs.contractFileUpload.startUpload()

        const uploaded = this.photosPath.find(f => f !== '')
        if (_this.formFields.id <= 0 && !uploaded) {
          _this.$Notice.error({ title: '请上传合同...' })
          _this.submit = false
          _this.loadingStatus = false
          return
        }

        // const formData = new FormData()
        // Object.keys(_this.formFields).forEach(key => {
        //   formData.append(key, _this.formFields[key])
        // })

        const photos = []
        for (const photoPath of this.photosPath) {
          photos.push(photoPath)
        }
        _this.formFields.photos = photos

        await request({
          url: this.action + (this.id ? '/' + this.id : ''),
          method: this.id ? 'PUT' : 'POST',
          data: _this.formFields
        }).then(res => {
          _this.loadingStatus = false
          _this.$Notice.success({ title: '合同上传成功' })
          _this.submit = false
          _this.closeModal(true)
        }).catch(() => {
          _this.loadingStatus = false
          _this.submit = false
          _this.$Notice.error({ title: '合同上传失败' })
        })
      }
    },
    closeModal: function(changed = false) {
      this.$emit('on-close', changed)
    }
  }
}
</script>

<style lang="less">
  .uploaded {
    border: 1px solid red;
  }
</style>

